import { TEMPORARY_BAN_DAYS } from "../../../../../constants/picker-entries-constants";
import getTBWStore from "../../../../../stores/tbw-store";
import ET3Div from "../../../../et3-div";
import { withLiteObserverAndTheme } from "../../../../et3-enhanced-render";
import ET3Radio from "../../../../et3-input/et3-radio";

const NumberOfTemporaryBanDays = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors, unitX } = theme;
  const TBWFromCase = getTBWStore().TBWFromCase.get();
  const isTemporaryBan = TBWFromCase === "temporary_banned";

  return isTemporaryBan ? (
    <ET3Div
      isScrollable={false}
      isExtendable={false}
      fDirection="row"
      justifyContent="center"
      alignItems="center"
      withShadow={false}
      width={1000}
      height={50}
      color={colors.all.transparent}
      style={{}}
      onClick={() => {}}
    >
      <ET3Radio
        options={TEMPORARY_BAN_DAYS}
        value={getTBWStore().temporaryBanDays.get()}
        onChoose={(value: number) => {
          getTBWStore().temporaryBanDays.set(value);
        }}
        style={{
          width: 900 * unitX
        }}
      />
    </ET3Div>
  ) : null;
});

export default NumberOfTemporaryBanDays;
